// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"CompanyScreen_buttonsContainer__dte3O","button":"CompanyScreen_button__1ojjl"};